import ResourceModal from 'app/components/ResourceModal';
import UploadForm from './UploadForm';

const UploadModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    multiple,
    center
  } = props;

  let action = 'create';
  let title = props.title || 'New Upload';
  let message = props.message;
  let unmountOnClose = true;

  const onSubmit = params => onFormSubmit(action, params);

  return (
    <ResourceModal {...{ isOpen, onClose, title, message, center, unmountOnClose }}>
      <UploadForm {...{ action, onClose, onSubmit, multiple }} />
    </ResourceModal>
  );
}

export default UploadModal;
